// @module TavanoTeam.CSExtensions.CSCertCapture.Checkout.NewCert.View
define('TavanoTeam.CSExtensions.CSCertCapture.Checkout.NewCert.View'
,	[
        'GlobalViews.Confirmation.View'
    ,   'Profile.Model'
    ,   'SC.Configuration'
        
    ,   'tavanoteam_csextensions_cscertcapture_checkoutext_newcert.tpl'

	,	'Utils'
	,	'Backbone'
	,	'jQuery'
	,	'underscore'
	]
,	function (
        GlobalViewsConfirmationView
    ,   ProfileModel
    ,   Configuration

	,   tavanoteam_csextensions_cscertcapture_checkoutext_newcert_tpl

	,	Utils
	,	Backbone
	,	jQuery
	,	_
	)
{
	'use strict';

	// @class TavanoTeam.CSExtensions.CSCertCapture.Checkout.NewCert.View @extends Backbone.View
	return Backbone.View.extend({

        template: tavanoteam_csextensions_cscertcapture_checkoutext_newcert_tpl

    ,	title: Utils.translate('Generate New Certificate')

	,	className: 'CheckoutCertificatesNew'

    ,	page_header: Utils.translate('Generate New Certificate')

    ,   initialize: function(options)
        {
            this.application = options.application;
            this.token = options.token;
            this.model = options.model;
            this.profile = options.profileModel;

            console.log("options", options);
        }

    ,   loadAvalaraCertCapture: function()
        {
            console.log("GenCert", GenCert);

            var certCaptureContainer = document.getElementById('in-modal-checkout-certcapture-container')
            ,   self = this
            ,   user_address = this.model.get('addresses')
            ,   userAddr = this.getDefaultShippingAddress(user_address)
            ,   userName = this.profile.get('name')
            ,   entityId = userName.substring(0, userName.indexOf(" "))
            ,   countries = Configuration.get('siteSettings.countries')
            ,   customer = {};

            //initialize CertCapture object
            GenCert.init(certCaptureContainer, {
                edit_purchaser: true
            ,   ship_zone: self.getStateName(userAddr.country, userAddr.state)
            ,   token: self.token.get('token')
            });

            //set customer's customer number (entityid from NS)
            GenCert.setCustomerNumber(entityId);

            //set customer information to autopopulate fields
            customer.name = this.profile.get('type') == 'COMPANY' ? this.profile.get('companyname') : this.profile.get('firstname') + " " + this.profile.get('lastname');
            customer.address1 = userAddr.addr1;
            customer.city = userAddr.city;
            customer.state = self.getStateName(userAddr.country, userAddr.state);
            customer.country = countries[userAddr.country].name;
            customer.zip = userAddr.zip;
            customer.phone = userAddr.phone;

            //send to CertCapture's ecommerce SDK
            GenCert.setCustomerData(customer);
            
            // show CertCapture's Wizard tool
            GenCert.show();
        }

    ,   getDefaultShippingAddress: function(addresses)
        {
            var addressObj = {};

            addresses.map(function(state)
            {
                if(state.get('defaultshipping') == 'T')
                {
                    addressObj.state = state.get('state');
                    addressObj.addr1 = state.get('addr1');
                    addressObj.city = state.get('city');
                    addressObj.country = state.get('country');
                    addressObj.zip = state.get('zip');
                    addressObj.phone = state.get('phone');
                }
            });

            return addressObj;
        }

    ,   getStateName: function(countryCode, stateCode)
        {
            //Since SCA is returning the State's code instead of the whole name
            //We need to pull up the State's name as this is what is needed by CertCapture
            //to auto populate the state field
            var countries = Configuration.get('siteSettings.countries')
            ,   stateName = '';
            
            _.each(countries[countryCode].states, function(state)
            {
                if(state.code == stateCode)
                {
                    stateName = state.name;
                }
            });

            return stateName;
        }

    ,   hasNoDefaultShipping: function(address)
        {
            var hasNoDefault = false;

            address.map(function(res)
            {
                if(res.get('defaultshipping') == 'T')
                {
                    hasNoDefault = true;
                }
            });

            return hasNoDefault;
        }

		//@method getContext @return TavanoTeam.CSExtensions.CSCertCapture.Checkout.NewCert.View.Context
	,   getContext: function getContext()
		{
            var user_address = this.model.get('addresses')
            ,   hasNoDefaultShipping = this.hasNoDefaultShipping(user_address);

            this.loadAvalaraCertCapture();
			//@class TavanoTeam.CSExtensions.CSCertCapture.Checkout.NewCert.View.Context
			return {
                pageHeader: this.page_header
            ,   hasNoAddress: hasNoDefaultShipping
            };
		}
	});
});
